export default {
  title: {
    create: 'Create Doctor Information',
    edit: 'Edit Doctor Information',
    productTotal: 'Total Product Value',
    formulaTotal: 'Total Formula Value',
    serviceTotal: 'Total Service Value'
  },
  label: {
    medicalDoctor: 'Attending Physician',
    recommendedRestPeriod: 'Recommended Rest Period by Doctor',
    doctorSection2: 'Doctor Section 2',
    compensation: 'Compensation',
    stepByStepFee: 'Step-by-Step Consultation Fee',
    fare: 'Consultation Fee',
    handlingFee: 'Handling Fee',
    doctorDF: 'Doctor DF Fee',
    assDF: 'Assistant DF Fee',
    treadDF: 'Attending Doctor DF Fee',
    typeOffare: 'Type of Fee',
    since: 'From Patient Number',
    stepUp: 'Step Increase',
    specialistDoctor: 'Specialist Doctor',
    overtimeFee: 'Overtime Fee (per hour)',
    inspectionDay: 'Inspection Day',
    infoCommission1: 'Formula commission is deducted from the profit of the formula as defined in system settings.',
    infoCommission2: 'Product commission is calculated from the individual product\'s defined commission rate.',
    professionalInformation: 'Professional Information',
    licenseNumber: 'Professional License Number',
    licenseNumberEng: 'Professional License Number (English)',
    professionalInfo: 'Professional Info',
    treatmentType: 'Type of Treatment',
    educationalRecord: 'Education History',
    contractDocument: 'Employment Contract Document',
    formulaCommission: 'Formula Commission',
    patientNeed: 'Patient Requires Medical Certificate',
    applicantPart1: 'Applicant Section 1 for Health Certificate',
    maleDoctorAndfemaleDoctor: 'Dr. / Female Doctor',
    type: 'Doctor Type'
  },
  placeholder: {
    typeOffare: 'Select type of fee',
    fare: 'Enter consultation fee',
    licenseNumber: 'Enter professional license number',
    licenseNumberEng: 'Enter professional license number (English)',
    treatmentType: 'Select type of treatment',
    educationalRecord: 'Enter education history',
    contractDocument: 'Attach employment contract document',
    formulaCommission: 'Enter formula commission',
    enterTypeInfo: 'Enter doctor type information'
  },
  header: {
    // Empty — can be filled later
  },
  tooltip: {
    printOPD: 'Print OPD Form',
    printOrder: 'Print Prescription',
    Order: 'Prescription'
  },
  button: {
    // Empty — can be filled later
  },
  alert: {
    createDoctorSuc: 'Doctor information created successfully!',
    editDoctorSuc: 'Doctor information updated successfully!',
    DeleteDoctorSuc: 'Doctor deleted successfully!',
    DF: 'Please select a DF calculation method'
  },
  status: {
    hourly: 'Hourly',
    daily: 'Daily',
    monthly: 'Monthly',
    yearly: 'Yearly',
    custom: 'Custom'
  },
  modal: {
    confirmDeleteDoctorTi: 'Confirm Doctor Deletion',
    confirmDeleteDoctorSub1: 'You are about to delete the doctor',
    confirmDeleteDoctorSub2: 'Do you want to continue?',
    create: {
      success: 'Doctor type created successfully!'
    },
    delete: {
      title: 'Confirm Doctor Deletion',
      subTitle: 'You are deleting a doctor',
      subTitle2: 'Do you want to continue?',
      success: 'Doctor deleted successfully'
    }
  },
  dayName: {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday'
  },
  dayNameShort: {
    Sunday: 'Sun',
    Monday: 'Mon',
    Tuesday: 'Tue',
    Wednesday: 'Wed',
    Thursday: 'Thu',
    Friday: 'Fri',
    Saturday: 'Sat'
  }
}
